<template>
  <div>
    <div :class="headerContainerClasses" @click="toggleOpen">
      <div v-if="!disabled" class="mobile-background" :class="{ 'order-1': isMobile }">
        <span v-if="isMobile">{{ isOpen ? 'Fechar' : 'Expandir' }}</span>
        <div :class="['expandable-custom-icon', { 'rotate-180': isOpen }]">
          <mf-icon color="marca-0-l10" size="20" icon="keyboard_arrow_down" />
        </div>
      </div>

      <div class="flex-1 slot-order">
        <slot name="header"></slot>
      </div>
    </div>
    <transition @before-enter="beforeEnter" @enter="enter" @leave="leave">
      <div v-if="isOpen" class="transition-wrapper">
        <slot name="content"></slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    hideBorders: {
      type: Boolean,
      default: false,
    },
    startOpen: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isOpen: false,
  }),
  computed: {
    headerContainerClasses() {
      return [
        'header-container',
        {
          'open-item-borders': this.isOpen && !this.hideBorders,
          borders: !this.hideBorders,
          'normal-padding': !this.dense,
          'dense-padding': this.dense,
        },
      ]
    },
  },
  mounted() {
    this.isOpen = this.startOpen
  },
  methods: {
    toggleOpen() {
      if (this.disabled) return
      this.isOpen = !this.isOpen
    },

    beforeEnter(el) {
      el.style.height = '0'
      el.style.opacity = '0'
      el.style.overflow = 'hidden'
    },

    enter(el, done) {
      const height = el.scrollHeight + 'px'
      el.style.transition = 'height 0.5s ease, opacity 0.5s ease'
      el.style.height = height
      el.style.opacity = '1'

      el.addEventListener('transitionend', function onTransitionEnd() {
        el.style.height = 'auto'
        el.style.overflow = ''
        el.removeEventListener('transitionend', onTransitionEnd)
        done()
      })
    },

    leave(el, done) {
      el.style.transition = 'height 0.3s ease, opacity 0.3s ease'
      el.style.height = el.scrollHeight + 'px'
      void el.offsetHeight
      el.style.height = '0'
      el.style.opacity = '0'

      el.addEventListener('transitionend', done)
    },
  },
}
</script>

<style lang="scss" scoped>
.header-container {
  overflow: hidden;
  transition: height 0.2s ease, border 0.2s ease, border-radius 0.2s ease;
  border-bottom: 1px solid $cinza-l70;

  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;

  @media screen and (max-width: $xs-breakpoint) {
    gap: 28px;
    flex-direction: column;
  }

  &:hover {
    cursor: pointer;
  }

  .transition-wrapper {
    overflow: hidden;
  }

  .flex-1 {
    flex: 1;
  }
}

.order-1 {
  order: 1;
}

.mobile-background {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  & span {
    font-size: 14px;
    font-weight: bold;
    color: $marca-0-l40;
  }
}

.normal-padding {
  padding: 28px 40px 20px 40px;

  @media screen and (max-width: $xs-breakpoint) {
    padding: 16px;
  }
}

.dense-padding {
  padding: 24px 16px 24px 24px;

  @media screen and (max-width: $xs-breakpoint) {
    padding: 16px;
  }
}

.borders {
  border: 1px solid $cinza-l70;
  border-radius: 8px;
}

.open-item-borders {
  border-bottom: transparent;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.expandable-custom-icon {
  background-color: #d2e9ff66;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.4s ease;

  &:hover {
    background-color: #b4dbff99;
  }
}

.expandable-custom-icon.rotate-180 {
  transform: rotate(180deg);
}
</style>
